import { render, staticRenderFns } from "./CreatePaymentAdditionalFields.vue?vue&type=template&id=dd2d18b2&scoped=true&"
import script from "./CreatePaymentAdditionalFields.vue?vue&type=script&lang=js&"
export * from "./CreatePaymentAdditionalFields.vue?vue&type=script&lang=js&"
import style0 from "./CreatePaymentAdditionalFields.vue?vue&type=style&index=0&id=dd2d18b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2d18b2",
  null
  
)

export default component.exports